// App.jsx - 메인 파일
import React from 'react';
import Header from './notes/Header';
import NotesMain from './notes/NotesMain';
import { useParams } from 'react-router';

function NotesPage() {
  const { id } = useParams();
  return (
    <div className="w-full min-h-screen ">
      <NotesMain />
    </div>
  );
}

export default NotesPage;
